import { Opcion } from '../../../models/catalogo.type'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

/**
 * Shape del formulario de usuario (react-hook-form).
 * Catalogos se manejan como `Opcion` (valor/etiqueta) y se normalizan al guardar.
 */
export type TUsuarioForm = {
  nombre: string
  apellidoPaterno: string
  apellidoMaterno: string
  correo?: string
  telefono: string | null | undefined
  divisionesNegocio: Opcion[]
  posicion: Opcion
  perfil: Opcion
  fechaActualizacion?: string
  fechaCreacion?: string
}

/**
 * Valida datos de usuario que impactan acceso, contacto y alcance operativo.
 * La division de negocio es obligatoria porque condiciona los sitios y flujos
 * que el usuario puede atender.
 */
export const schema = yup.object({
  nombre: yup.string().trim().required('El nombre es requerido'),
  apellidoPaterno: yup.string().trim().required('El primer apellido es requerido'),
  telefono: yup
    .string()
    .nullable()
    .test('longitud', 'Mínimo 10 caracteres', (value) => {
      return !value || value.trim().length >= 10
    }),
  correo: yup.string().trim().required('El correo es requerido').email('Correo inválido'),
  divisionesNegocio: yup
    .array()
    .of(yup.object().required('La división de negocio es requerida').nullable())
    .min(1, 'Selecciona al menos una divisón de negocio')
    .nullable(),
  posicion: yup.object().required('La posición es requerida').nullable(),
  perfil: yup.object().required('El perfil es requerido').nullable(),
})

export const useUsuarioForm = () => {
  return useForm<TUsuarioForm>({
    mode: 'all',
    resolver: yupResolver(schema),
  })
}
